



















import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class TopBar extends Vue {

  get getTab() {
    return this.$route.name == 'recorridos' ? 'recorridos' : 'directions'
  }

  public openMenu() {
    this.$store.dispatch('openSideMenu')
  }

  public gotoDirections() {
    ;(this as any).$ga.event('tabs', 'directions')
    this.$store.dispatch('setTab', 'directions')
    const ciudad = this.$store.getters.getCiudad
    let ciudadSlug = ciudad.slug
    if (!ciudad.id) {
      ciudadSlug = `${ciudad.slug}|${ciudad.latlng[1]},${ciudad.latlng[0]}`
    }
    this.$router.push(`/${ciudadSlug}/`)
  }

  public gotoRecorridos() {
    ;(this as any).$ga.event('tabs', 'recorridos')
    this.$store.dispatch('setTab', 'recorridos')
    const ciudad = this.$store.getters.getCiudad
    let ciudadSlug = ciudad.slug
    if (!ciudad.id) {
      ciudadSlug = `${ciudad.slug}|${ciudad.latlng[1]},${ciudad.latlng[0]}`
    }
    this.$router.push(`/${ciudadSlug}/recorridos/`)
  }

  public share() {
    if (navigator.share) {
      navigator
        .share({
          title: 'Cualbondi',
          url: window.location.href,
        })
        .then(() => console.log('Successful share'))
        .catch(error => console.log('Error sharing', error))
    } else {
      this.$store.dispatch('setShareModal', true)
    }
  }

}
